import { render, staticRenderFns } from "./help-icon.vue?vue&type=template&id=b08cc002&"
var script = {}
import style0 from "./help-icon.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports